import React from 'react'
import {
  ModalStyled,
  Container,
  Title,
  Description,
  PresentationImage,
  Main,
  Footer,
  ContainerInfos,
  ContainerCenter
} from './ModalProductNews.styles'
import { Button } from 'components/lib/buttons'
import { colors } from 'config/ui'
import {
  ContainerOnlyBigScreens,
  ContainerOnlySmallScreens
} from 'styles/common/Common.styles'
import { useTranslation } from 'i18n'

const ModalProductNews = ({
  presentationImage,
  category,
  title,
  description,
  show,
  textButton,
  onClose,
  closeLabel,
  onAction,
  onSecondaryAction,
  actionLabel,
  fullScreen,
  canCloseByXBtn
}) => {
  const { t } = useTranslation()
  return (
    <ModalStyled
      fullScreen={fullScreen}
      show={show}
      onClose={onClose}
      canCloseByXBtn={canCloseByXBtn}
      type="no-header"
      canCloseByOverlay={true}
    >
      <Main>
        <Container>
          <ContainerOnlySmallScreens>
            <PresentationImage src={presentationImage.mobile} />
          </ContainerOnlySmallScreens>
          <ContainerOnlyBigScreens>
            <PresentationImage src={presentationImage.desktop} />
          </ContainerOnlyBigScreens>
        </Container>
        <ContainerInfos>
          <ContainerCenter>
            <p>
              <strong>{category}</strong>
            </p>
            <Title>{title}</Title>
            <Description>{description}</Description>
          </ContainerCenter>
        </ContainerInfos>
      </Main>
      <Footer>
        {onSecondaryAction && (
          <Button
            data-testid="closeModal"
            newSize={'large'}
            noTextTransform
            onClick={onSecondaryAction}
            outline
            color={colors.gray}
            textColor={colors.darkGray}
          >
            {closeLabel || textButton || t('Começar')}
          </Button>
        )}
        {onAction && (
          <Button
            data-testid="onActionButton"
            newSize={'large'}
            primary
            noTextTransform
            onClick={onAction}
          >
            {actionLabel || 'Ok'}
          </Button>
        )}
      </Footer>
    </ModalStyled>
  )
}

export default ModalProductNews
